export const hasUploadedGoogleProfilePhoto = review => {
  try {
    const url = new URL(review.author_avatar);
    return url.protocol === 'https:' && /(^|\.)googleusercontent\.com$/i.test(url.hostname) && url.pathname.startsWith('/a-/');
  } catch (_) { return false; }
};
